// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__4FVsf","content":"RecentSearches_content__3d3ph"};